import { cva } from '@/styled-system/css';

export const menuItemRecipe = cva({
  base: {
    'position': 'relative',
    'display': 'block',
    'paddingBlock': 'tight',
    'paddingInline': 'default',
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'background-color 200ms ease, color 200ms ease',
    },
    'width': '100%',
    'cursor': 'pointer',

    'backgroundColor': {
      base: 'bg.elevated.mediumShadow',

      _notDisabled: {
        _hover: 'bg.action.neutral.alt.hover',
        _active: 'bg.action.neutral.alt.pressed',
      },
    },

    '_notDisabled': {
      _hover: {
        '&:where(a) > [data-c11n-component="Menu.ItemLabel"]': {
          textDecoration: 'underline',
        },
      },
    },

    '_focusVisible': {
      '& > [data-c11n-component="Menu.ItemLabel"]': {
        boxShadow: 'focus',
      },
    },
    '_hover': {
      '& > [data-c11n-component="Menu.ItemLabel"]': {
        boxShadow: 'none',
      },
    },

    '&:has([data-c11n-component="Menu.ItemIcon"])': {
      display: 'grid',
      gridTemplate: `
        "icon label" auto
        "icon meta" auto / auto auto
      `,
      justifyContent: 'start',
      columnGap: 'tighter',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
  },
});
